;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { isDevManagementEnabled, MVAULT_ENDPOINT, TVAULT_ENDPOINT } from '@/lib/constants'
import safeFetch from '@/lib/helpers/safe-fetch'
import * as fakeMvault from './mvault'
import * as fakeTvault from './tvault'
import { createCacheFakeStore } from './store/cache-store'

// Path relative to the mount, i.e. what comes after the endpoint's pathname.
// `.../api/v1/WTCI/subscriptions/` against endpoint `.../api/v1` → `/WTCI/subscriptions/`.
function pathBelowMount(routeUrl: URL, endpoint: string): string {
  const mountPath = new URL(endpoint).pathname.replace(/\/$/, '')
  const below = routeUrl.pathname.slice(mountPath.length)
  return below.startsWith('/') ? below : `/${below}`
}

/**
 * Drop-in replacement for safeFetch on MVault/TVault routes that fake
 * scenarios cover. When dev management tooling is enabled (staging / local,
 * never production), the request is first offered to the in-process fake
 * handlers; they answer only for users who have seeded fake state AND
 * explicitly toggled fakes on (or for mvault_ids belonging to such state).
 * Everything else falls through to the real upstream via safeFetch with the
 * original arguments. The in-process Request is never reused, so consumed
 * bodies are not a hazard.
 */
export async function vaultFetch(route: string, init?: RequestInit): Promise<Response> {
  // Production short-circuit: no fake code runs at all. isDevManagementEnabled
  // also requires both vault endpoints to look staging/local, as defense in depth.
  if(!isDevManagementEnabled) {
    return safeFetch(route, init)
  }

  const url = new URL(route)
  const store = createCacheFakeStore()

  let result: Response | null = null
  if(route.startsWith(MVAULT_ENDPOINT)) {
    result = await fakeMvault.handle(new Request(route, init), url, pathBelowMount(url, MVAULT_ENDPOINT), store)
  } else if(route.startsWith(TVAULT_ENDPOINT)) {
    result = await fakeTvault.handle(new Request(route, init), url, pathBelowMount(url, TVAULT_ENDPOINT), store)
  }

  return result ?? safeFetch(route, init)
}
